










































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities } from '@/types'
import {
  IStatusForSelection,
  IWorkflowDetail,
} from '@/api/types/response.types'
import { IWorkflowsInputUpdateStatusTransitions } from '@/api/types/request.types'

/* API */
import WorkflowsAPI from '@/api/modules/workflows.api'
import typeAssistant from '@/helpers/type-assistant'

export default Vue.extend({
  name: 'WorkflowStatusTransitionsModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    workflow: {
      type: Object as () => IWorkflowDetail,
      required: true,
    },
    currentStatusId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      isSubmitting: false,
      transtionableStatusIDs: [] as Number[],
      entityType: EEntities.PROJECTS,
    }
  },

  computed: {
    internalShowModal: {
      get(): boolean {
        return this.showModal
      },
      set(newValue: boolean) {
        this.$emit('update:showModal', newValue)
      },
    },
    hasCurrentStatusID(): boolean {
      return this.currentStatusId !== null
    },
    availableStatusesToTransitionTo(): IStatusForSelection[] {
      return this.workflow.listStatuses.filter(
        s => s.id !== this.currentStatusId,
      )
    },
    hasNoStatusTransitions(): boolean {
      return this.transtionableStatusIDs.length === 0
    },
    currentStatus(): IStatusForSelection {
      return this.workflow.listStatuses.find(s => s.id === this.currentStatusId)
    },
    submitBtnColor(): string {
      return ColorAssistant.getEntityColor(this.entityType)
    },
    subtitle(): string {
      if (this.hasCurrentStatusID) {
        return `When a task is set to <strong>${
          this.currentStatus.name
        }</strong>, the status can be updated to any of the following…`
      }
      return ''
    },
  },

  watch: {
    currentStatusId: {
      immediate: true,
      handler(val) {
        if (val === null) {
          return
        }
        this.transtionableStatusIDs = this.workflow.listStatusTransitions
          .filter(t => t.statusIDFrom === this.currentStatusId)
          .map(t => t.statusIDTo)
      },
    },
  },

  created() {
    this.entityType = typeAssistant.getEntityType(this.workflow.entityTypeID)
  },

  methods: {
    closeModal() {
      this.internalShowModal = false
    },
    isSelectedStatusTransition(status: IStatusForSelection) {
      return this.transtionableStatusIDs.includes(status.id)
    },
    toggleStatusTransition(status: IStatusForSelection) {
      if (this.isSelectedStatusTransition(status)) {
        this.transtionableStatusIDs = this.transtionableStatusIDs.filter(
          id => id !== status.id,
        )
      } else {
        this.transtionableStatusIDs.push(status.id)
      }
    },
    async updateStatusTransitions() {
      try {
        this.isSubmitting = true
        const data = {
          id: this.currentStatusId,
          listAvailableStatusesToMoveToIDs: this.transtionableStatusIDs,
        } as IWorkflowsInputUpdateStatusTransitions

        const response = await WorkflowsAPI.put_UpdateStatusTransitions(
          this.workflow.id,
          data,
        )
        this.$emit('status-transitions-updated')
        this.closeModal()
      } catch (err) {
        this.$error.emit(err, true)
        return false
      } finally {
        this.isSubmitting = false
      }
    },
  },
})
